import type { LucideIcon } from 'lucide-react';
import { Building2, Home, Mountain } from 'lucide-react';

// Caminhos do wizard de presupuesto. tipoPropiedad usa o enum do backend
// (home | business | campo); 'contacto_generico' é reservado ao form de contacto.
export type WizardPathId = 'home' | 'business' | 'campo';

export interface WizardQuestion {
  id: string;
  question: string;
  options: string[];
}

export interface WizardPath {
  id: WizardPathId;
  label: string;
  description: string;
  icon: LucideIcon;
  questions: WizardQuestion[];
}

export const WIZARD_PATHS: WizardPath[] = [
  {
    id: 'home',
    label: 'Hogar',
    description: 'Casas y departamentos',
    icon: Home,
    questions: [
      {
        id: 'tipo_vivienda',
        question: '¿Qué tipo de vivienda tenés?',
        options: ['Casa', 'Departamento'],
      },
      {
        id: 'accesos',
        question: 'Número de accesos desde el exterior',
        options: ['1 o 2', 'Entre 3 y 5', 'Más de 6'],
      },
      { id: 'jardin', question: '¿Cuenta con jardín o patio exterior?', options: ['Sí', 'No'] },
      {
        id: 'robo_previo',
        question: '¿Han robado alguna vez en tu propiedad?',
        options: ['Sí', 'No'],
      },
      {
        id: 'monitoreo_camaras',
        question: '¿Te interesa monitoreo con cámaras?',
        options: ['Sí, quiero ver todo', 'No por ahora'],
      },
    ],
  },
  {
    id: 'business',
    label: 'Negocio',
    description: 'Locales y oficinas',
    icon: Building2,
    questions: [
      {
        id: 'tipo_negocio',
        question: '¿Qué tipo de negocio tenés?',
        options: ['Local a la calle', 'Shopping / Galería', 'Oficina Corporativa', 'Otro'],
      },
      {
        id: 'tamano',
        question: 'Tamaño aproximado del local',
        options: ['Pequeño (<50m²)', 'Mediano (50-200m²)', 'Grande (>200m²)'],
      },
      {
        id: 'horario',
        question: '¿En qué horario opera?',
        options: ['Horario Oficina', 'Extendido / Nocturno', '24 Horas'],
      },
      { id: 'empleados', question: '¿Cuántos empleados?', options: ['1-5', '6-20', 'Más de 20'] },
    ],
  },
  {
    id: 'campo',
    label: 'Campo',
    description: 'Estancias y propiedades rurales',
    icon: Mountain,
    questions: [
      {
        id: 'tipo_rural',
        question: '¿Qué tipo de propiedad rural?',
        options: ['Estancia Ganadera', 'Cultivo / Agrícola', 'Agroindustrial', 'Casa de Campo'],
      },
      { id: 'extension', question: 'Extensión', options: ['<50 Ha', '50-500 Ha', '>500 Ha'] },
      {
        id: 'distancia_urbano',
        question: 'Distancia a zona urbana',
        options: ['<10 km', '10-50 km', '>50 km'],
      },
      {
        id: 'activos_criticos',
        question: 'Activos críticos',
        options: ['Ganado', 'Maquinaria', 'Silos / Galpones', 'Todo lo anterior'],
      },
    ],
  },
];
